import React from "react";
import Skeleton from "@mui/material/Skeleton";

export function AnalysisTableRowSkeleton({ index, hiddenHeaders = [] }) {
    return (
        <tr key={index}>
            <td>
                <Skeleton variant="rectangular" width={18} height={18} />
            </td>
            {hiddenHeaders.includes("NOTES") ? null : (
                <td>
                    <div className="list-inline mb-0">
                        <Skeleton variant="circular" width={30} height={30} />
                    </div>
                </td>
            )}
            {hiddenHeaders.includes("RULE NAME") ? null : (
                <td>
                    <Skeleton variant="text" width="80%" height={24} />
                </td>
            )}
            {hiddenHeaders.includes("DESCRIPTION") ? null : (
                <td>
                    <Skeleton variant="text" width="90%" height={24} />
                </td>
            )}
            {hiddenHeaders.includes("COMPLIANCE") ? null : (
                <td>
                    <Skeleton variant="text" width={120} height={24} />
                </td>
            )}
            {hiddenHeaders.includes("SECTION") ? null : (
                <td>
                    <Skeleton variant="text" width={120} height={24} />
                </td>
            )}
            {hiddenHeaders.includes("SUBSECTION") ? null : (
                <td>
                    <Skeleton variant="text" width={140} height={24} />
                </td>
            )}
            {hiddenHeaders.includes("CREATED BY") ? null : (
                <td>
                    <Skeleton variant="text" width={100} height={24} />
                </td>
            )}
            {hiddenHeaders.includes("SEVERITY") ? null : (
                <td>
                    <Skeleton variant="rectangular" width={70} height={24} className="oct_skeleton-radius-4" />
                </td>
            )}
            {hiddenHeaders.includes("VALID") ? null : (
                <td>
                    <Skeleton variant="rectangular" width={70} height={24} className="oct_skeleton-radius-4" />
                </td>
            )}
            {hiddenHeaders.includes("GROUP") ? null : (
                <td>
                    <Skeleton variant="text" width={100} height={24} />
                </td>
            )}
            <td>
                <button className="oct_dropdown-trigger-v2 oct_skeleton-dropdown-btn" disabled>
                    <Skeleton variant="circular" width={24} height={24} />
                </button>
            </td>
        </tr>
    );
}

export default AnalysisTableRowSkeleton;
